
@if (formValue) {
<form class="d-flex flex-column h-100" [formGroup]="formValue" (ngSubmit)="submitPlatformStudySite()" novalidate>
  <!-- Meril Logo -->
  <!-- <span><img src="../../../assets/Images/meril-logo.png" class="LoginMerilLogo"></span> -->
  
  <h6 class="loginH2">Welcome</h6>
  <hr class="mt-0 hr-loginpage" />
  <!-- Study & Role -->
  <h5 class="loginH5">Study & Role</h5>

  <div class="mb-2">
    @for (roleSites of configureRoleStudySelectionBox(); track roleSites.formNameControlData; let i = $index) {
      @if((roleSites.multiSelectData && roleSites.multiSelectData.length > 0) || i <= 1) {
        <label class="form-label login-label">{{roleSites.multiSelectPlaceholder}}<span class="text-danger">*</span></label>
        <ng-select
            appendTo="body"
            [attr.data-testid]="roleSites.testid"
            [dropdownPosition]="'bottom'"
            [items]="roleSites.multiSelectData"
            [bindLabel]="roleSites.showLabel"
            [bindValue]="roleSites.getSelectedValue"
            [multiple]="roleSites.isMultiple"
            [searchable]="roleSites.isSearchable"
            [closeOnSelect]="roleSites.isCloseOnSelect"
            [clearable]="roleSites.isClearable"
            [formControlName]="roleSites.formNameControlData"
            [placeholder]="roleSites.multiSelectPlaceholder"
            (change)="
              onSelectionChange();
              roleSites.formNameControlData === platform ? onPlatformItemSelect($event) : null;
              roleSites.formNameControlData === role ? onRoleItemSelect($event) : null
            ">
        </ng-select>
        <div class="text-danger small">
          @if (roleSites.formNameControlData === platform && platformNotSelected) {
            {{platformNotSelected}}
          } @else if (roleSites.formNameControlData === role && roleNotSelected) {
            {{roleNotSelected}}
          } @else if (roleSites.formNameControlData === study && studyNotSelected) {
            {{studyNotSelected}}
          }
        </div>
      }
    }
  </div>

  <div class="sticky-bottom-buttons">
    <div class="row mt-3">
      <div class="col-6">
        <button type="reset" class="btn btn-cancel w-100 mb-4" data-testid="btn-cancel" (click)="cancelLogin()" [disabled]="loading">Cancel</button>
      </div>
      <div class="col-6">
        <button type="submit" class="btn btn-submit w-100 mb-4" data-testid="btn-submit" [disabled]="loading">Submit
        </button>
      </div>
    </div>
    <div class="text-center mt-2">
    </div>
  </div>
</form>
}